import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import messages from '../../../messages';
import styles from './styles.module.less';

const ConfirmDeletionModal = ({ isDeleting, onConfirm, packingSlip }) => {
  return (
    <Modal size='small'>
      <ModalHeader>
        <FormattedMessage {...messages.deleteConfirmationTitle} />
      </ModalHeader>
      <ModalBody className={styles.body}>
        {!isDeleting && (
          <>
            <div>
              <FormattedMessage {...messages.askToDelete} />
            </div>
            <div className={styles.name}>{packingSlip.name}</div>
          </>
        )}
        {isDeleting && <LoadingIndicator className={styles.loading} />}
      </ModalBody>
      <ModalFooter>
        <ModalFooterCancelButton />
        <Button onClick={() => onConfirm(packingSlip.packingSlipId)} testId='confirm-delete-btn' theme='danger'>
          <FormattedMessage {...messages.delete} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ConfirmDeletionModal.propTypes = {
  isDeleting: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  packingSlip: PropTypes.shape({
    name: PropTypes.string,
    packingSlipId: PropTypes.string,
  }).isRequired,
};

export default ConfirmDeletionModal;
